import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer className="footer-overunity">
      <a
        href="https://www.overunity.ca/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit OverUnity Digital website"
      >
        <img
          src="https://www.overunity.ca/user/assets/typhoon/overunity-logo@4x.png"
          alt="OverUnity Digital"
        />
      </a>
    </footer>
  )
}

export default Footer

